module.exports = __webpack_public_path__ + "6a10d437bf8226dcfffe1f96daddc745.svg";